module.exports = "/images/note-line-top-left-bottom-right.svg?02a69756d4546e66b12523aa55ef43db";